import type { Resource } from '../../';
export const account_accountInformation_orderHistory: Resource = {"default":"Order History"};
